export default __webpack_public_path__ + "8b3ae1dd6cacf63e3e389a83f5ebb2f4.svg";